















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component
export default class MinimisedCard extends Vue {
  @Prop({ type: String, required: true })
  public modalTitle!: string;

  /**
   * Default empty string ensures we always have a valid value,
   * preventing errors when null/undefined is passed.
   */
  @Prop({ type: String, default: '' })
  public modalContent!: string;

  @State((state) => state.unsavedChangesGuard.isUnsavedChangesDialogActive)
  public isConfirmationDialogActive!: boolean;
}
